import React from 'react';

import { ButtonBase } from '@mui/material';

import * as Models from 'contracts/models';
import { useUserLogout } from 'queries/user-action/use-user-logout';

import useStyles from './styles';

import LogOutIcon from '../../assets/logout.svg';

interface Props {
    user: Models.UserInfo.User;
    className?: string;
}

const UserEmail: React.FC<Props> = ({ user, className }) => {
    const { classes, cx } = useStyles();
    const userLogoutMutation = useUserLogout({ onSuccess: () => window.location.assign('/search') });

    return (
        <div className={cx(classes.root, className)}>
            <span className={classes.email}>{user.email}</span>
            <ButtonBase
                disableRipple
                className={classes.logout}
                disabled={userLogoutMutation.isPending}
                onClick={userLogoutMutation.mutate}
            >
                <LogOutIcon />
            </ButtonBase>
        </div>
    );
};

export default UserEmail;
